// extracted by mini-css-extract-plugin
export default {"box":"AccountInformation_box__7xOWM"};